import type { Client, RequestContext } from "../client";
import type { SensitiveValue, GitCredentialRepositoryRestrictionsResource, PaginatedCollection } from "../resources/index";
import type { PlatformHubGitCredentialResource } from "../resources/platformHubGitCredentialResource";
export class PlatformHubGitCredentialRepository {
    private client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    create(gitCredential: CreatePlatformHubGitCredentialCommand) {
        return this.client.post<CreatePlatformHubGitCredentialResponse>(this.requestContext, "~/api/platformhub/git-credentials", gitCredential);
    }
    async get(args?: GetPlatformHubGitCredentialsRequest) {
        const response = await this.client.get<GetPlatformHubGitCredentialsResponse>(this.requestContext, "~/api/platformhub/git-credentials{?skip,take,name}", args);
        return response.GitCredentials;
    }
    async getById(gitCredentialId: string) {
        const response = await this.client.get<GetPlatformHubGitCredentialByIdResponse>(this.requestContext, "~/api/platformhub/git-credentials/{gitCredentialId}", { gitCredentialId });
        return response.GitCredential;
    }
    async modify(gitCredential: ModifyPlatformHubGitCredentialCommand) {
        await this.client.put<ModifyPlatformHubGitCredentialResponse>(this.requestContext, "~/api/platformhub/git-credentials/{id}", gitCredential, { id: gitCredential.Id });
    }
    delete(gitCredentialId: string) {
        return this.client.del(this.requestContext, "~/api/platformhub/git-credentials/{id}", null, { id: gitCredentialId });
    }
}
export interface CreatePlatformHubGitCredentialCommand {
    Name: string;
    Description?: string;
    Details: NewGitCredentialDetails;
    RepositoryRestrictions?: GitCredentialRepositoryRestrictionsResource;
}
export interface NewGitCredentialDetails {
    Username: string;
    Password: SensitiveValue;
}
export interface CreatePlatformHubGitCredentialResponse {
    Id: string;
}
export type GetPlatformHubGitCredentialsRequest = {
    Skip?: number;
    Take?: number;
    Name?: string;
};
export interface GetPlatformHubGitCredentialsResponse {
    GitCredentials: PaginatedCollection<PlatformHubGitCredentialResource>;
}
export interface GetPlatformHubGitCredentialByIdResponse {
    GitCredential: PlatformHubGitCredentialResource;
}
export interface ModifyPlatformHubGitCredentialCommand {
    Id: string;
    Name: string;
    Description?: string;
    Details: ModifyGitCredentialDetails;
    RepositoryRestrictions?: GitCredentialRepositoryRestrictionsResource;
}
export interface ModifyGitCredentialDetails {
    Username: string;
    Password: SensitiveValue;
}
export interface ModifyPlatformHubGitCredentialResponse {
}
export interface DeletePlatformHubGitCredentialResponse {
}
